import React, { Component } from 'react';

class Resume extends Component {

  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  render() {

    if(this.props.data){
      var skillmessage = this.props.data.skillmessage;
      var education = this.props.data.education.map(function(education){
        return <div key={education.school}><h3>{education.school}</h3>
                <p className="info">{education.degree}</p>
                <div className="date"> Graduated : {education.graduated}</div>
                <p>{education.description}</p></div>
      });
      var research = this.props.data.research.map(function(research){
        return <div style={{marginBottom:'10px'}} key={research.stage}><h3>{research.stage}</h3>
            <p className="info">{research.title}</p>
            <p>{research.description}</p>
            <p style={{color:'black'}}>{research.publication}</p>
        </div>
      })

    }

    return (
      <section id="resume">

      <div className="row education">
         <div className="three columns header-col">
            <h1><span>Education</span></h1>
         </div>

         <div className="nine columns main-col">
            <div className="row item">
               <div className="twelve columns">
                 {education}
               </div>
            </div>
         </div>
      </div>


      <div className="row research">

         <div className="three columns header-col">
            <h1><span>Research</span></h1>
         </div>

         <div className="nine columns main-col">
          {research}
        </div>
    </div>
   </section>
    );
  }
}

export default Resume;



// WEBPACK FOOTER //
// ./src/Components/Resume.js